export default __webpack_public_path__ + "static/domea-4-99487df56d6000ef28a23d0c16976386.jpg";